<template>
  <div class="track-add" v-loading="loading">
    <panel-head title="转化追踪" subtitle="Transformation tracking"></panel-head>
    <div class="panel-content">
      <h3 class="panel-content__title">转化追踪</h3>
      <up-form
        class="panel-content__form"
        ref="formData"
        :model="formData"
        :rules="rules"
        label-width="120px"
      >
        <up-form-item-input label="转化名称：" prop="name" v-model="formData.name" placeholder="请输入转化名称"></up-form-item-input>
        <up-form-item-input label="下载链接：" prop="download" v-model="formData.download" placeholder="请输入下载链接"></up-form-item-input>
        <up-form-item-input label="应用包名：" prop="app" v-model="formData.app" placeholder="请输入应用包名"></up-form-item-input>
        <up-form-item-select label="转化目标" prop="type" v-model="formData.type" :data="eventTypes" placeholder="请选择转化目标"></up-form-item-select>
        <up-form-item-input label="点击检测链接：" prop="click" v-model="formData.click" placeholder="请输入点击检测链接"></up-form-item-input>
        <up-form-item-input label="展示检测链接：" prop="display" v-model="formData.display" placeholder="请输入展示检测链接"></up-form-item-input>
        <div class="panel-content__btn-group">
          <div class="panel-content__btn" v-if="type !== 'view'">
            <el-button size="large" @click="submitForm('formData')">{{ submitText }}</el-button>
          </div>
          <div class="panel-content__btn">
            <el-button
              size="large"
              class="is-cancel"
              @click="$router.go(-1)"
            >{{ type === 'view' ? '返回' : '取消' }}</el-button>
          </div>
        </div>
      </up-form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { PanelHead } from '@/global/components'

const REGEXP_WEBSITE_URL = /^https?:\/\//

export default {
  name: 'TrackAdd',
  data() {
    const validateUrls = (fieldText) => (rule, value, callback) => {
      if (value === '') {
        callback(new Error(`请输入${fieldText}`))
      } else if (!REGEXP_WEBSITE_URL.test(value)) {
        callback(new Error(`${fieldText}必须以 http 或 https 开头`))
      } else {
        callback()
      }
    }

    return {
      platform: '',
      type: '',
      id: '',
      loading: false,
      formData: {
        name: '',
        download: '',
        app: '',
        type: '',
        click: '',
        display: ''
      },
      rules: {
        name: [{ required: true, message: '请输入转化名称', trigger: 'blur' }],
        download: [
          { required: true, message: '请输入下载链接', trigger: 'change' },
          { validator: validateUrls('下载链接'), trigger: 'blur' }
        ],
        app: [{ required: true, message: '请输入应用包名', trigger: 'blur' }],
        type: [{ required: true, message: '请选择下载链接', trigger: 'change' }],
        click: [
          { required: true, message: '请输入点击检测链接', trigger: 'change' },
          { validator: validateUrls('点击检测链接'), trigger: 'blur' }
        ],
        display: [ { required: true, message: '请输入展示检测链接', trigger: 'change' },
          { validator: validateUrls('展示检测链接'), trigger: 'blur' }
        ]
      },
      eventTypes: [],
      submitting: false,
      submitted: false
    }
  },
  async created() {
    const { type, id = '' } = this.$route.params
    this.platform = this.$route.meta.platform
    this.type = type
    this.id = id
    this.loading = true

    this.getEventTypes()

    if (this.id) {
      const [err, res] = await this['track/getTrack']({ platform: this.platform, id: this.id })
      if (err) this.$message.error('获取转化信息失败！')
      else {
        const { name, download, app, type, click, display } = res.data
        this.formData = Object.assign({}, this.formData, {
          name, download, app, type: String(type), click, display
        })
      }
    }
    this.loading = false
  },
  computed: {
    submitText () {
      return this.submiting ? '提交中...' : (this.submited ? '已提交' : '提交')
    }
  },
  methods: {
    ...mapActions([
      'track/getEventTypes',
      'track/getTrack',
      'track/addTrack',
      'track/updateTrack'
    ]),
    async getEventTypes () {
      const [err, res] = await this['track/getEventTypes']({ platform: this.platform })
      if (err || res.code !== 1) this.$message.error(res.msg || '获取事件类型失败')
      else this.eventTypes = res.data || []
    },
    submitForm (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.submitting || this.submitted) return this.$message.error('请勿重复提交员工信息')
          this.submitting = true

          const operText = this.type === 'copy' ? '复制' : this.id ? '编辑' : '添加'
          let res, err
          if (!this.id || this.type === 'copy') {
            [err, res] = await this['track/addTrack']({ platform: this.platform, params: this.formData })
          } else {
            [err, res] = await this['track/updateTrack']({ platform: this.platform, params: this.formData, id: this.id })
          }
          this.submitting = false
          if (err) return this.$message.error(`${operText}转化失败`)
          else if (res.code !== 1) this.$message.error(res.msg)
          else {
            this.submitted = true
            this.$message.success(`${operText}转化成功`)
            setTimeout(() => {
              this.$router.push(`/track`)
            }, 2000)
          }
        }
      })
    }
  },
  components: {
    PanelHead
  }
}
</script>

<style lang="scss">

</style>
